/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { breakpointsMap } from '@oneaudi/unified-web-common';
import { useEnvConfigContext, AuthContext } from '@oneaudi/myaudi-kit-utils';
import { ConsentModal, saveConsentToStorage, useGoogleConsent } from '@oneaudi/two-click';
import { ProgressIndicator } from '@oneaudi/unified-web-components';
import { useWindowSize } from '../../../hooks/useWindowSize';
import MobileLayout from '../MobileLayout/MobileLayout';
import DesktopLayout from '../DesktopLayout/DesktopLayout';
import useResultsByTermAndAddress from '../../../hooks/useResultsByTermAndAddress';
import useResultsByGeoLocation from '../../../hooks/useResultsByGeoLocation';
import useResultsByGeoArea from '../../../hooks/useResultsByGeoArea';
import mapContext from '../../../contexts/map-context';
import { useGeolocation } from '../../../hooks/useMapGeolocation';
import { useMapQueryParam } from '../../../hooks/useMapQueryParams';
import { useResultByDealerId } from '../../../hooks/useResultByDealerId';
import { GlobalStyleReset } from '../../common/GlobalStyleReset';
import { TwoClickConsentWrapper } from '../../common/TwoClickConsentModal/style';
import { getFavoritePartner, getRatingSummary, getRatings, getReviews } from '../../../api';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import { useInitialQueryParams } from '../../../hooks/useInitialQueryParams';
import { SearchParams } from '../../../models/common/searchParams';
import { generateBaseUrl } from '../../../utils/generateBaseUrl';
import { LoaderContainer } from '../../../FeatureApp';
import { useConnectDealerByGeo } from '../../../hooks/useConnectDealerToDealerContext';

const isLegacy = process.env.IS_LEGACY;

const MapLayout: React.FC = () => {
  const windowSize = useWindowSize();
  const {
    myAudiCtaConfig,
    isMapTriggeredByTeaser,
    twoClickConsentRequired,
    twoClickData,
    locale,
    fiveStarData,
    oneHeader,
    activeMobileView,
    autoConnectDealer,
  } = mapContext.useMapState();
  const { triggerGeolocationSearch } = useGeolocation();
  const { parseInitialParams } = useInitialQueryParams();
  const authService = React.useContext(AuthContext);

  const consent = useGoogleConsent();

  useResultsByGeoArea();
  useMapQueryParam();
  useResultByDealerId();
  useResultsByTermAndAddress();
  useResultsByGeoLocation();

  if (autoConnectDealer) {
    useConnectDealerByGeo();
  }

  const dispatch = mapContext.useMapDispatch();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const config = useEnvConfigContext<any>();

  const searchParams: SearchParams = parseInitialParams();

  const dispatchAccessToken = () => {
    dispatch({
      type: ActionTypes.setAccessToken,
      payload: authService,
    });
  };

  const getFavPartner = async () => {
    if (await authService.isAuthenticated()) {
      try {
        const partnerObj = await getFavoritePartner(authService, locale);

        const hasError = Object.prototype.hasOwnProperty.call(partnerObj, 'message');

        if (hasError) {
          dispatch({
            type: ActionTypes.setErrorMessage,
            payload: { code: partnerObj?.code, message: partnerObj?.message },
          });
        } else {
          dispatch({
            type: ActionTypes.setFavoritePartner,
            payload: partnerObj,
          });
          dispatch({
            type: ActionTypes.setAccessToken,
            payload: authService,
          });
        }
      } catch {
        // Error handling - could be logged to service in production
      }
    }
  };

  React.useEffect(() => {
    if (isMapTriggeredByTeaser) {
      triggerGeolocationSearch();
    }
  }, []);

  React.useEffect(() => {
    getFavPartner();
    dispatchAccessToken();
  }, [authService, config]);

  React.useEffect(() => {
    const searchParamsDealerId = searchParams['dealer-id'];

    const updateFiveStarResults = async () => {
      const ReviewsPromise = getReviews(searchParamsDealerId || '');
      const RatingSummaryPromise = getRatingSummary(searchParamsDealerId || '');
      Promise.all([ReviewsPromise, RatingSummaryPromise]).then((results) => {
        const [dealerReviews, ratingSummary] = results;
        dispatch({ type: ActionTypes.setDealerReviews, payload: dealerReviews });
        dispatch({ type: ActionTypes.setRatingSummary, payload: ratingSummary });
        if (searchParams.reviews === true) {
          setTimeout(() => {
            dispatch({ type: ActionTypes.setIsFlyoutOpen, payload: true });
          });
        }
      });
    };

    const updateDealerRatings = async () => {
      const dealerRatings = await getRatings();
      dispatch({ type: ActionTypes.setDealerRatings, payload: { dealerRatings } });
    };

    if (fiveStarData.displayFiveStarRating) {
      updateDealerRatings();
      if (searchParamsDealerId) {
        updateFiveStarResults();
      }
    }
  }, []);

  const revokeConsent = () => {
    setTimeout(() => saveConsentToStorage(false), 1000);
  };

  const showMyAudiCloseButton = myAudiCtaConfig
    ? Object.prototype.hasOwnProperty.call(myAudiCtaConfig, 'cancelCta')
    : false;

  const desktopBackgroundImg = `${generateBaseUrl()}${isLegacy ? '/desktop_map.png' : '/desktop_map_alpha.png'}`;
  const mobileBackgroundImg = `${generateBaseUrl()}${isLegacy ? '/mobile_map.png' : '/mobile_map_alpha.png'}`;

  return (
    <GlobalStyleReset>
      <TwoClickConsentWrapper
        desktopImg={desktopBackgroundImg}
        mobileImg={mobileBackgroundImg}
        isDesktop={windowSize.width > parseInt(breakpointsMap.md, 10)}
        oneHeader={oneHeader}
        isListView={activeMobileView === 'list'}
        isLegacy={isLegacy}
      >
        {typeof window !== 'undefined' ? (
          <>
            {!consent && twoClickConsentRequired ? (
              <ConsentModal
                theme="light"
                headerText={twoClickData.headline}
                bodyText={twoClickData.copyText}
                toggleText={twoClickData.toggleLabel}
                redirectButtonText={twoClickData.closeButton?.text || 'Back to homepage'}
                redirectButtonURL={twoClickData.closeButton?.redirectURL || '/'}
                showRedirectButton={!showMyAudiCloseButton}
                showCloseButton={showMyAudiCloseButton}
                closeButtonCallback={
                  myAudiCtaConfig?.cancelCta && myAudiCtaConfig.cancelCta.clickHandler
                }
              />
            ) : windowSize.width < parseInt(breakpointsMap.md, 10) || oneHeader ? (
              <MobileLayout data-test-id="component-mobile-layout" revokeConsent={revokeConsent} />
            ) : (
              <DesktopLayout
                data-test-id="component-desktop-layout"
                revokeConsent={revokeConsent}
              />
            )}
          </>
        ) : (
          <LoaderContainer>
            <ProgressIndicator
              variant="spinner"
              type="infinite"
              data-test-id="mobile-layout-component"
            />
          </LoaderContainer>
        )}
      </TwoClickConsentWrapper>
    </GlobalStyleReset>
  );
};

export default MapLayout;
